import { ICreateThemeColorsParams } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

import { HANTEC_GENERIC_THEME_COLORS } from './tenant/hantec';

export const HANTEC_LIGHT_THEME_COLORS: ICreateThemeColorsParams = {
  ...HANTEC_GENERIC_THEME_COLORS,
  background: {
    default: 'rgb(255, 255, 255)'
  }
};

// No customisation needed for default
export const LIGHT_THEME_COLORS: ICreateThemeColorsParams = {};
